import Api from '@/interceptors/Api';
import MgrApi from '@/interceptors/MgrApi';
import MgrPrivate from '@/interceptors/MgrPrivate';
import MgrPublic from '@/interceptors/MgrPublic';

export interface HttpClient {
  get<T>(url: string, config?: { params?: Record<string, unknown> }): Promise<T>;
  post<T>(url: string, data?: unknown): Promise<T>;
  put<T>(url: string, data?: unknown): Promise<T>;
  patch<T>(url: string, data?: unknown): Promise<T>;
}

export const mgrPrivate = MgrPrivate as unknown as HttpClient;
export const mgrPublic = MgrPublic as unknown as HttpClient;
export const mgrApi = MgrApi as unknown as HttpClient;
export const dashboardApi = Api as unknown as HttpClient;
